module.exports = __webpack_public_path__ + "img/荔枝.6085f392.jpg";